import { useServiceBanner } from "@/modules/layout/hooks/use-service-banner";

import { ServiceBanner } from "./service-banner";

/**
 * Connects the polled banner endpoint to the presentational component.
 *
 * On error `data` is `undefined` and nothing renders — a broken status check
 * must never break the app shell.
 */
export const ServiceBannerHost = () => {
  const { data } = useServiceBanner();

  if (!data?.enabled || data.message.trim().length === 0) {
    return null;
  }

  return <ServiceBanner message={data.message} />;
};
